const knowledge = {
  title: "Brain",
  description: "Manage your workspace Brain",
  v2: {
    overview: "Overview",
    overviewComingSoon: "The overview dashboard arrives in the next step of the redesign.",
    groups: {
      base: "Base",
      infrastructure: "Infrastructure",
    },
    documents: {
      count: "{{count}} items",
      generatingEmbeddings: "generating embeddings…",
    },
    embeddings: {
      count: "{{count}} vectors",
      searchBy: "Search by",
      metadataCount: "{{count}} metadata",
      noMetadata: "no metadata",
    },
    contexts: {
      draft: "Draft",
      selectToEdit: "Select a context to edit",
    },
    overviewStats: {
      avgQuality: "Average quality",
      healthy: "Healthy base",
      synced: "Everything synced",
      assimilation: "Assimilation",
      lastUpdate: "Last update",
      publishedContexts: "Published contexts",
      recentDocuments: "Recent documents",
      seeAll: "See all",
      relativeNow: "now",
      relativeMin: "{{count}} min ago",
      relativeHours: "{{count}} h ago",
    },
  },
  tabs: {
    imports: "Imports",
    transformation: "Transformation",
    storage: "Files",
    pipelines: "Pipelines",
    database: "Database",
    documents: "Documents",
    embeddings: "Embeddings",
    settings: "Settings"
  },
  fields: {
    type: "Type",
    name: "Name",
    description: "Description",
    status: "Status",
    created_at: "Created At",
    actions: "Actions"
  },
  actions: {
    import: "Import",
    upload: "Upload",
    create: "Create",
    edit: "Edit",
    delete: "Delete",
    search: "Search",
    openMenu: "Open menu",
    view: "View Details",
    actions: "Actions",
    filter: "Filter",
    next: "Next",
    previous: "Previous",
    clear: "Clear",
    cancel: "Cancel",
    save: "Save",
  },
  common: {
    search: "Search",
    searchPlaceholder: "Search in Brain...",
    error: "Error",
    success: "Success",
    actions: "Actions",
    delete: "Delete",
    cancel: "Cancel",
    view: "View",
    openMenu: "Open menu",
    deleteSuccess: "Item deleted successfully",
    deleteError: "Error deleting item",
    none: "None",
    actionOptions: {
      delete: "Delete"
    }
  },
  imports: {
    title: "Storage",
    description: "Store and manage your data from different sources",
    add: "Add",
    search: "Search documents...",
    error_loading: "Error loading storage data",
    no_data: "No storage data found",
    no_workspace: 'No workspace selected',
    no_knowledge: 'No active Brain found',
    details: {
      description: "View storage item details"
    },
    fields: {
      file: "File",
      name: "Name",
      type: "Type",
      category: "Category",
      status: "Status",
      size: "Size",
      description: "Description",
      namePlaceholder: "Import name",
      descriptionPlaceholder: "Import description",
      created_at: "Created At",
      updated_at: "Updated At",
      file_size: "Size",
      actions: "Actions",
      metadata: 'Metadata',
      quality: 'Quality',
      source: 'Source'
    },
    metadata: {
      title: 'Document metadata',
      source: 'Source',
      sourcePlaceholder: 'e.g. manual, meeting_scriber, api',
      subject: 'Subject',
      subjectPlaceholder: 'What is this document about?',
      language: 'Language',
      languagePlaceholder: 'e.g. pt-BR, en-US',
      tags: 'Tags',
      tagsPlaceholder: 'Comma-separated tags'
    },
    empty: {
      title: "No storage items found",
      description: "Add a new storage item to get started"
    },
    messages: {
      success: "Data stored successfully",
      error: "Error storing data",
      deleted: "Storage item deleted successfully",
      fetchError: "Error loading storage items",
      createSuccess: "Storage item created successfully",
      createError: "Error creating storage item",
      successFileUpload: "File uploaded successfully",
      successFileUploadDescription: "The file {{file}} was uploaded successfully.",
      deleteSuccess: "Storage item deleted successfully",
      deleteError: "Error deleting storage item"
    },
    validation: {
      requiredField: "Required field",
      requiredFieldDescription: "The import name is required.",
      requiredFields: "Required fields",
      requiredFieldsDescription: "The following fields are required: {{fields}}"
    },
    upload: {
      title: "Upload document",
      subtitle: "PDF, Word, PowerPoint, Excel, CSV, JSON or Markdown",
      dragText: "Drag and drop a file here",
      orText: "or",
      selectButton: "Select a file",
      maxSizeText: "Max size: {{size}}",
      error: "Upload error",
      fileTooLarge: "File is too large. Maximum size: {{size}}",
      unsupportedType: "Unsupported file format. Accepted formats: {{type}}",
      emptyFile: "The file is empty. Choose a file with content.",
      corruptedFile: "This file could not be processed: it seems to be corrupted or does not match its extension. Check the file and try again.",
      fileRequired: "Select a file to upload.",
      types: {
        pdf: "PDF document",
        word: "Word document",
        powerpoint: "PowerPoint presentation",
        excel: "Excel spreadsheet",
        csv: "CSV spreadsheet",
        json: "JSON file",
        markdown: "Markdown document"
      },
      removeFile: "Remove file",
      sending: "Uploading file",
      completed: "Upload completed"
    },
    schedule: {
      enabled: "Schedule enabled",
      frequency: "Frequency",
      frequencies: {
        hourly: "Hourly",
        daily: "Daily",
        weekly: "Weekly", 
        monthly: "Monthly"
      },
      interval: "Interval",
      intervalPlaceholder: "Enter interval",
      startTime: "Start time",
      daysOfWeek: "Days of week",
      dayOfMonth: "Day of month",
      dayOfMonthPlaceholder: "Enter day of month",
      days: {
        0: "Sun",
        1: "Mon",
        2: "Tue",
        3: "Wed",
        4: "Thu",
        5: "Fri",
        6: "Sat"
      }
    }
  },
  storage: {
    title: 'Files',
    description: 'Manage the files of your Brain',
    showing: 'Showing {{start}} to {{end}} of {{total}} items',
    itemsPerPage: 'Items per page',
    noResults: 'No items found',
    actions: {
      import: 'Import',
      upload: 'Upload',
      search: 'Search documents...',
      filter: 'Filter',
      clear: 'Clear search',
      download: 'Download',
      delete: 'Delete',
      viewDetails: 'View details',
      info: 'Info'
    },
    source: {
      manual: 'Manual',
      automatic: 'Automatic',
      unknown: '—'
    },
    origin: {
      column: 'Sent by',
      unknown: '—',
      channels: {
        ui: 'Screen',
        external_agent: 'External agent',
        prodgy_chat: 'Prodgy chat',
        workspace_job: 'Job',
        teams: 'Microsoft Teams'
      },
      textOnly: 'Text only',
      textOnlyHint: 'Only the text of this document was sent, not the original file.'
    },
    details: {
      title: 'Document details',
      tabs: {
        details: 'Details',
        metadata: 'Metadata',
        quality: 'Quality',
        chunks: 'Chunks'
      },
      fields: {
        fileName: 'File name',
        fileSize: 'File size',
        fileType: 'File type',
        metadata: 'Metadata',
        facets: 'Facets'
      },
      noMetadata: 'No metadata',
      quality: {
        empty: 'No quality estimates available for this document',
        overall: 'Overall quality',
        completeness: 'Completeness',
        relevance: 'Relevance',
        notAvailable: 'Not available',
        processing: 'Processing',
        totalChunks: 'Total chunks',
        processedChunks: 'Processed chunks',
        chunkMethod: 'Chunking strategy',
        documentType: 'Document type',
        model: 'Model',
        provider: 'Provider',
        processedAt: 'Processed at'
      },
      chunks: {
        total: '{{count}} chunks',
        empty: 'No chunks indexed for this document'
      },
      tabular: {
        schema: 'Schema',
        sheets: 'Sheets',
        rowCount: '{{count}} rows',
        columnCount: '{{count}} columns',
        degraded: {
          title: 'Sheet(s) indexed in descriptive mode',
          description: 'Sheets with complex formatting could not become a queryable table: they remain searchable by meaning, but do not answer exact queries/aggregations (sums, totals, counts, filters).',
          ruleLabel: 'When does this happen?',
          rule: 'When a sheet has many merged cells, multi-level headers, unnamed columns or irregular rows. For exact answers, use a clean rectangular table (one header, one value per cell).'
        }
      }
    },
    status: {
      active: 'Active',
      pending: 'Pending',
      completed: 'Completed',
      failed: 'Failed',
      embedded: 'Embedded',
      processing: 'Processing',
      stored: 'Stored',
      partial: 'Partial'
    },
    fields: {
      type: 'Type',
      name: 'Name',
      description: 'Description',
      created_at: 'Created At',
      updated_at: 'Updated At',
      file_size: 'Size',
      actions: 'Actions',
      status: 'Status'
    },
    empty: {
      title: 'No storage items found',
      description: 'Get started by importing your first item.'
    },
    errors: {
      loading: 'Error loading storage data',
      deleting: 'Error deleting file',
      downloading: 'Error downloading file',
      downloadFailed: 'Download failed. Please try again.'
    },
    messages: {
      downloadSuccess: 'File downloaded successfully',
      downloading: 'Downloading file...'
    },
    confirmDelete: {
      title: 'Delete file',
      description: 'Are you sure you want to delete this file? This action cannot be undone.'
    },
    quickFilters: {
      all: 'All',
      type: 'Type',
      facets: 'Facets',
      clear: 'Clear',
      emptyTypes: 'No types available',
      emptyFacets: 'No facets available',
      noMatches: 'No documents match the applied filters'
    }
  },
  pipelines: {
    title: 'Pipelines',
    description: 'Manage your Brain pipelines',
    showing: 'Showing {{start}} to {{end}} of {{total}} pipelines',
    showing_pipelines: 'Showing {{start}} to {{end}} of {{total}} pipelines',
    itemsPerPage: 'Items per page',
    noResults: 'No pipelines found',
    no_data: 'No pipelines found',
    addPipelineTitle: 'Add Pipeline',
    addPipelineDescription: 'Select a pipeline available for installation in your Brain',
    available_templates: '{{count}} pipeline templates available',
    available_templates_hint: 'Browse curated pipelines and install the one that matches your scenario.',
    no_available_pipelines: 'No pipelines available for installation',
    integrations: 'Tools',
    no_results: 'No results',
    install_pipeline: 'Install Pipeline',
    no_description: 'No description',
    pipeline_label: 'Pipeline template',
    steps_count: '{{count}} installation steps',
    quick_install: 'Quick install',
    search_placeholder: 'Search by name, description or tool...',
    actions: {
      create: 'Pipeline',
      search: 'Search pipelines...',
      filter: 'Filter',
      clear: 'Clear search',
      edit: 'Edit',
      delete: 'Delete'
    },
    status: {
      active: 'Active',
      inactive: 'Inactive',
      error: 'Error'
    },
    fields: {
      name: 'Name',
      description: 'Description',
      created_at: 'Created At',
      updated_at: 'Updated At',
      status: 'Status',
      actions: 'Actions'
    },
    empty: {
      title: 'No pipelines found',
      description: 'Get started by creating your first pipeline.'
    },
    errors: {
      loading: 'Error loading pipelines',
      deleting: 'Error deleting pipeline'
    },
    confirmDelete: {
      title: 'Delete pipeline',
      description: 'Are you sure you want to delete this pipeline? This action cannot be undone.'
    }
  },
  embeddings: {
    title: "Embeddings",
    description: "Manage Brain embeddings",
    noResults: "No embeddings found",
    noEmbeddings: "No embeddings found",
    showing: "Showing {{start}} to {{end}} of {{total}} embeddings",
    itemsPerPage: "Items per page:",
    search: "Search embeddings...",
    details: "Embedding Details",
    basicInfo: "Basic Information",
    view_details: "View Details",
    fetchError: "Error loading embeddings",
    fetchDetailError: "Error loading embedding details",
    deleteSuccess: "Embedding deleted successfully",
    deleteError: "Error deleting embedding",
    deleteConfirmTitle: "Delete Embedding",
    deleteConfirmDescription: "Are you sure you want to delete this embedding? This action cannot be undone.",
    fields: {
      id: "ID",
      content: "Content",
      metadata: "Metadata",
      version: "Version",
      insertedAt: "Inserted At",
      knowledgeId: "Brain ID",
      actions: "Actions"
    }
  },
  security: {
    tabTitle: "Security",
    title: "Security",
    description: "Irreversible actions for the Brain.",
    cleanupTitle: "Clean Brain",
    cleanupDescription: "Removes all embeddings, storage files and data associated with the Brain. This action is permanent and cannot be undone.",
    cleanupButton: "Clean All",
    confirmTitle: "Confirm Brain cleanup",
    confirmDescription: "This action is irreversible. Type the product name to confirm.",
    confirmLabel: "Type the product name to confirm:",
    confirmButton: "Confirm and Clean",
    cleanupSuccess: "Brain cleaned successfully",
    cleanupError: "Error cleaning Brain",
    cleanupErrorDescription: "An error occurred while trying to clean the Brain.",
    cleanupErrorInvalid: "Product not found",
    cleanupErrorNameMismatch: "The product name does not match",
    deleting: "Cleaning...",
    deletingTitle: "Cleaning Brain",
    deletingDescription: "Removing embeddings and data from {{name}}...",
    deletingStep: "Removing data",
    deletingMessage: "Please wait while we remove all data...",
    deletedMessage: "Cleanup completed",
    noKnowledgeBase: "No product selected"
  },
  transformation: {
    title: "Transformation",
    description: "Transform and prepare your data",
    add: "Add transformation",
    nodes: "Transformation Nodes",
    fields: {
      name: "Name",
      type: "Type",
      status: "Status",
      createdAt: "Created At",
      updatedAt: "Updated At",
      actions: "Actions"
    },
    empty: {
      title: "No transformations found",
      description: "Add a new transformation to get started"
    },
    messages: {
      success: "Transformation saved successfully",
      error: "Error saving transformation",
      deleted: "Transformation deleted successfully",
      fetchError: "Error loading transformations",
      createSuccess: "Transformation created successfully",
      createError: "Error creating transformation",
      deleteSuccess: "Transformation deleted successfully",
      deleteError: "Error deleting transformation"
    }
  },
  database: {
    title: "Database",
    description: "Manage your Brain",
    add: "Add database",
    fields: {
      name: "Name",
      type: "Type",
      status: "Status",
      createdAt: "Created At",
      updatedAt: "Updated At",
      actions: "Actions"
    },
    empty: {
      title: "No databases found",
      description: "Add a new database to get started"
    },
    messages: {
      success: "Database saved successfully",
      error: "Error saving database",
      deleted: "Database deleted successfully",
      fetchError: "Error loading databases",
      createSuccess: "Database created successfully",
      createError: "Error creating database",
      deleteSuccess: "Database deleted successfully",
      deleteError: "Error deleting database"
    }
  },
  errors: {
    subscriptionRequired: "Subscription Expired/Exhausted",
    subscriptionRequiredDescription: "Add more credits or upgrade your plan to continue uploading files.",
    uploadFailed: "Upload failed",
    genericUploadError: "An error occurred while uploading the file. Please try again."
  },
  brain: {
    tabs: {
      mind: "Mind",
      knowledge: "Knowledge",
      memory: "Memory",
      learnings: "Learnings",
    },
    settings: {
      open: "Brain settings",
      title: "Brain settings",
      description: "Settings that apply to the whole Brain of this workspace.",
    },
  },
  soul: {
    title: "Soul",
    readOnly: "Read only",
    save: "Save Soul",
    saving: "Saving...",
    saved: "Soul saved. New conversations start with it.",
    saveError: "Could not save the Soul.",
    discard: "Discard changes",
    history: "History",
    historyTitle: "Soul history",
    historyDescription: "Every saved version, with who saved it and when. Restoring creates a new version with the old text.",
    noHistory: "No versions saved yet.",
    version: "Version {{version}}",
    current: "Current",
    initialVersion: "Initial text",
    by: "by {{name}}",
    restore: "Restore",
    restored: "Version {{version}} restored.",
    restoreError: "Could not restore this version.",
    edit: "Edit Soul",
    empty: "This workspace has no Soul yet.",
    emptyAdmin: "This workspace has no Soul yet. Use the pencil to write who it is.",
  },
  mind: {
    lock: "Lock block",
    unlock: "Unlock block",
    locked: "Locked: nobody changes it, not even here, until it is unlocked",
    lockError: "Could not change the lock.",
    lockDirty: "Save or discard this block's changes before locking it.",
    lockedKept: "The unlocked blocks were removed; {{count}} locked block(s) stayed.",
    clearPartial: "{{count}} block(s) could not be removed and are still listed. Try again.",
    missingDescription: "Describe when to read this block: if it comes cut or only in the index, the description is what tells the agent when to open it.",
    saveBlock: "Save block",
    blockSaved: "Block saved.",
    blockSaveError: "Could not save the block.",
    loadBudget: "Mind load limit",
    loadBudgetHint: "How many characters of the Mind the agent receives when loading the Brain. Short blocks come whole; long ones come cut and the agent reads the rest when needed.",
    loadBudgetRange: "Characters, from {{min}} to {{max}}.",
    loadBudgetSaved: "Mind limit saved. New conversations already use it.",
    loadBudgetSaveError: "Could not save the Mind limit.",
    loadBudgetLoadError: "Could not load the Mind limit.",
    readOnlyNote: "Only administrators change the Mind.",
    selectBlock: "Select a block to see it",
    changes: "Changes",
    changesTitle: "Mind changes",
    changesDescription: "Every change to the Mind, with who made it, where it came from and the content before and after. Undoing a change brings the block back to how it was.",
    noChanges: "No changes recorded yet.",
    before: "Before",
    after: "After",
    removed: "(removed)",
    undo: "Undo",
    undone: "Undone",
    undoSuccess: "Change undone.",
    undoError: "Could not undo this change.",
    sources: {
      ui: "Screen",
      conversation: "Conversation",
      workflow: "Flow",
    },
    actions: {
      create: "Created",
      update: "Changed",
      delete: "Deleted",
      restore: "Restored",
    },
  },
  overview: {
    title: "Mind",
    description: "Document important workspace details",
    search_placeholder: "Search the Mind...",
    sections: "Sections",
    section_titles: {
      vision: "Product Vision",
      product_vision: "Product Vision",
      value_proposition: "Value Proposition",
      target_audience: "Target Audience",
      stakeholders: "Stakeholders",
      user_personas: "User Personas",
      key_features: "Key Features",
      non_functional_requirements: "Non-Functional Requirements",
      technical_architecture: "Technical Architecture",
      risks_dependencies: "Risks & Dependencies",
      success_metrics: "Success Metrics",
      milestones_deadlines: "Milestones & Deadlines",
      resources: "Resources",
      section_1: "Section 1",
      section_2: "Section 2",
      section_3: "Section 3",
      section_4: "Section 4",
      section_5: "Section 5",
      section_6: "Section 6",
      section_7: "Section 7",
      section_8: "Section 8",
      section_9: "Section 9",
      section_10: "Section 10",
    },
    ai_hint: "You can generate or review all Mind blocks with AI using this button.",
    editor_ai_hint: "Regenerate this section's content with AI.",
    add_block: "Add Section",
    add: "Add",
    write: "Write",
    upload: "Import",
    upload_description: "Import from markdown files",
    upload_success: "{{count}} section(s) imported successfully",
    upload_error: "Failed to import file",
    upload_empty: "No content found in file",
    upload_invalid_type: "Invalid file type — only .md or .zip accepted",
    drop_to_import: "Drop to import",
    no_search_results: "No sections match your search.",
    add_description: "Write your own definitions",
    generate_description: "Let AI create them for you",
    generate_single_description: "Edit the prompt below to guide the AI in generating this section.",
    publish: "Publish",
    edit_block: "Edit Section",
    generate_blocks: "Generate with AI",
    generate_section_title: "Generate Section with AI",
    generate_content: "Generate Content",
    no_workspace: "Select a workspace to view the Mind",
    no_blocks: "The Mind of this workspace is empty. Add definitions manually or let AI generate them for you.",
    block_title: "Section Title",
    block_title_placeholder: "Section Title",
    new_section_title: "New Section",
    new_section_description: "Describe the content of this section",
    field_name: "Technical Name",
    field_name_help: "Name used in placeholders (ex: vision, target_audience). Will be auto-generated from title.",
    block_description: "Description",
    description_placeholder: "Optional section description",
    block_type: "Section Type",
    content: "Content",
    fill_required_fields: "Fill all required fields",
    block_created: "Section created successfully",
    block_updated: "Section updated successfully",
    block_deleted: "Section deleted successfully",
    blocks_generated: "Sections generated successfully",
    content_generated: "Content generated successfully",
    error_loading: "Error loading sections",
    error_creating: "Error creating section",
    error_updating: "Error updating section",
    error_deleting: "Error deleting section",
    error_generating: "Error generating sections",
    error_generating_content: "Error generating content",
    error_reordering: "Error reordering sections",
    field_name_exists: "A section with this technical name already exists for this workspace",
    field_name_placeholder: "vision, target_audience, pain_points",
    content_placeholder_text: "Enter text...",
    content_placeholder_textarea: "Enter content...",
    content_placeholder_link: "https://example.com",
    content_placeholder_link_label: "Link name",
    content_placeholder_link_url: "URL",
    content_placeholder_add_link: "Add Link",
    content_placeholder_add_item: "Add Item",
    content_placeholder_language: "Language",
    block_types: {
      text: { label: "Simple Text", description: "A single line of text", short: "text" },
      textarea: { label: "Text Area", description: "Multiple lines of text", short: "text" },
      rich_text: { label: "Formatted Text", description: "Text with Markdown formatting", short: "text" },
      link: { label: "Link", description: "A single link", short: "link" },
      links: { label: "Link List", description: "Multiple links", short: "links" },
      list: { label: "List", description: "List of items", short: "list" },
      checklist: { label: "Checklist", description: "List with checkboxes", short: "list" },
      code: { label: "Code", description: "Code block", short: "code" },
      quote: { label: "Quote", description: "Quote block", short: "quote" },
      callout: { label: "Callout", description: "Colored callout box", short: "callout" },
      user_personas: { label: "User Personas", description: "Key user personas with goals, pain points, and characteristics", short: "group" },
      group: { label: "Group", description: "Group of items with name, description, and characteristics", short: "group" }
    },
    read_only: "read-only",
    group_items: "Items",
    group_item: "Item",
    unsaved_changes_title: "Unpublished changes",
    unsaved_changes_description: "You have changes that haven't been published yet. If you leave now, these changes will be lost.",
    unsaved_changes_continue: "Continue Editing",
    unsaved_changes_discard: "Discard and Leave",
    pending_changes_banner: "You have unpublished changes. Click Publish to save.",
    undo_changes: "Undo",
    pending_changes_short: "Unpublished changes",
    publish_success: "Your sections have been saved and published to the Mind.",
    all_blocks_cleared: "All sections and embeddings have been removed successfully.",
    include_in_knowledge: "Include in Brain",
    include_in_knowledge_help: "When enabled, this section will be available as a placeholder in the RAG Assistant",
    block_activated: "Section activated successfully",
    block_deactivated: "Section deactivated successfully",
    error_toggling: "Error toggling section status",
    title_exists: "A section with this title already exists",
    sync_to_kb: "Sync to KB",
    syncing_description: "Generating Mind blocks...",
    generating: "Generating sections...",
    blocks_synced_to_kb: "sections synced to Brain",
    error_syncing_to_kb: "Error syncing sections to Brain",
    sync_started: "Sync started - sections are being synced to Brain in background",
    persona: "Persona",
    personas: "Personas",
    persona_goals: "Goals:",
    persona_pain_points: "Pain Points:",
    persona_characteristics: "Characteristics:",
    sync_block_to_kb: "Sync this section to Brain",
    block_synced_to_kb: "Section synced to Brain",
    error_syncing_block: "Error syncing section",
    recreate_content: "Recreate content with AI",
    editing: "Editing",
    view_mode: "Preview",
    edit_mode: "Edit",
    recreating: "Recreating content...",
    content_recreated: "Content recreated successfully",
    error_recreating: "Error recreating content",
    view_markdown: "View as Markdown",
    view_normal: "View normal",
    view_full_content: "View full content",
    view_more: "View more",
    recreate_confirm_title: "Recreate Content?",
    recreate_confirm_description: "This will replace all current content with new AI-generated content. This action cannot be undone.",
    recreate_confirm_action: "Recreate",
    delete_confirm_title: "Delete section?",
    delete_confirm_description: "This action cannot be undone. The section and its content will be permanently removed.",
    delete_confirm_action: "Delete",
    recreate_all_blocks: "Recreate",
    recreate_all_confirm_title: "Recreate All Sections?",
    recreate_all_confirm_description: "This will delete all current sections and generate 10 standard Mind blocks using AI. All current content will be lost. This action cannot be undone.",
    recreate_all_confirm_action: "Recreate All",
    blocks_recreated: "sections recreated successfully",
    blocks_failed_recreate: "sections failed to recreate",
    error_recreating_all: "Error recreating sections",
    generate_confirm_title: "Generate Sections?",
    generate_confirm_description: "This will automatically generate Mind blocks using AI.",
    generate_confirm_action: "Generate",
    settings: "Settings",
    settings_title: "Mind Settings",
    settings_tab_ai: "AI",
    settings_tab_security: "Security",
    settings_ai_title: "AI Generation",
    settings_prompt_description: "Select a template below or write your own custom prompt to generate the Mind blocks.",
    settings_prompt_placeholder: "Select a template above or write a custom prompt here...",
    settings_templates_title: "Templates",
    settings_templates_loading: "Loading templates...",
    settings_templates_error: "Could not load templates. You can still write a custom prompt.",
    settings_clear_prompt: "Clear",
    settings_default_prompt: `Create Mind blocks covering the following aspects:

1. Solution Vision - What this project is about, its objectives, strategic context, and long-term vision
2. Value Proposition - What makes this solution unique and its differentiators
3. Stakeholders - Key people, teams, and roles involved in the project
4. Target Audience - Primary users, customer segments, and who benefits
5. User Personas - Key user profiles (3-5) with goals, pain points, and behaviors
6. Key Features - Core features, capabilities, and expected behaviors
7. Non-Functional Requirements - Performance, security, scalability, and availability expectations
8. Technical Architecture - Stack, tools, infrastructure, and key technical decisions
9. Risks & Dependencies - Known risks, assumptions, blockers, and external dependencies
10. Success Metrics - KPIs, acceptance criteria, and how success is measured
11. Milestones & Roadmap - Key deliverables, phases, deadlines, and planned iterations
12. Resources - Links, repositories, environments, documentation, and references

Generate detailed, specific content based on the project context. Avoid generic text.`,
    settings_security_title: "Danger Zone",
    settings_security_description: "Destructive actions that cannot be undone.",
    settings_clear_title: "Clear the Mind",
    settings_clear_description: "Removes all sections permanently. This action cannot be undone.",
    settings_clear_action: "Clear All",
    settings_clear_confirm: "Are you sure? All unlocked blocks will be permanently deleted; locked ones stay.",
    settings_regenerate_title: "Regenerate with AI",
    settings_regenerate_description: "Deletes the unlocked blocks and generates new ones using AI based on the configured prompt; locked ones stay.",
    settings_regenerate_action: "Regenerate All",
    settings_regenerate_hint: "The prompt above will be used to regenerate all Mind blocks.",
    settings_max_tokens: "Max Tokens",
    settings_temperature: "Temperature",
    settings_generate_title: "Generate the Mind",
    settings_generate_action: "Generate"
  }
} as const;

export default knowledge;
